import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.isAuth) {
      this.router.navigateByUrl('/public/dashboard');
    } else {
      this.router.navigateByUrl('/public/dashboard');
    }
    return false;
  }
}
